import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const RecordSummaryWidget = ({ stats }) => (
  <Card className="card-hover" data-testid="record-summary">
    <CardContent className="p-6">
      <div className="flex items-center justify-center gap-8 flex-wrap">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-6 h-6 text-emerald-500" strokeWidth={1.5} />
          <span className="text-3xl font-bold text-gray-900">{stats?.wins || 0}</span>
          <span className="text-sm text-gray-500">Wins</span>
        </div>
        <div className="w-px h-10 bg-gray-200 hidden sm:block"></div>
        <div className="flex items-center gap-2">
          <Minus className="w-6 h-6 text-amber-500" strokeWidth={1.5} />
          <span className="text-3xl font-bold text-gray-900">{stats?.draws || 0}</span>
          <span className="text-sm text-gray-500">Draws</span>
        </div>
        <div className="w-px h-10 bg-gray-200 hidden sm:block"></div>
        <div className="flex items-center gap-2">
          <TrendingDown className="w-6 h-6 text-red-500" strokeWidth={1.5} />
          <span className="text-3xl font-bold text-gray-900">{stats?.losses || 0}</span>
          <span className="text-sm text-gray-500">Losses</span>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default RecordSummaryWidget;
